import React from 'react'

export default function TruncateText(props) {
  const { children, textCount, wrapperClasses, dropdownWrapperClass, htmlContent } = props

  return (
    <div className={`d-flex align-content-center ${wrapperClasses || ''}`}>
      <span>{children?.length > textCount ? `${children.slice(0, textCount)}...` : children}</span>
      {children?.length > textCount &&
        <div className={`dropdown ${dropdownWrapperClass} bg-transparent ml-2`}>
          <a className="dropdown-toggle bg-transparent text-primary" type="button" data-toggle="dropdown" aria-expanded="false">
            Read More
          </a>
          <div className="dropdown-menu width-25">
            <span className="dropdown-item text-wrap" dangerouslySetInnerHTML={{ __html: htmlContent || children }}/>
            </div>
        </div>
      }
    </div>
  )
}
